import { render, staticRenderFns } from "./AIModelInference.vue?vue&type=template&id=482286b2&"
import script from "./ai-model-inference.js?vue&type=script&lang=js&"
export * from "./ai-model-inference.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports